import LazyLoad from "vanilla-lazyload";

export default () => {
    const inst = new LazyLoad({
        elements_selector: '[data-bg]'
    });
    inst.loadAll();
}
